<div class="one" fxLayout="column" [formGroup]="MotorVehicleAccidentForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE),
      }"
    >
      <mat-label>Accident Date</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATETEXT"
        (dateInput)="AccidentDateClick('input', $event)"
        (dateChange)="AccidentDateClick('change', $event)"
        matInput
        [matDatepicker]="AccidentDate"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE2),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE2),
      }"
    >
      <mat-label>Accident Date 2</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE2?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATE2TEXT"
        (dateInput)="AccidentDate2Click('input', $event)"
        (dateChange)="AccidentDate2Click('change', $event)"
        matInput
        [matDatepicker]="AccidentDate2"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate2"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate2></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE2) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE2.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE2?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE3),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE3),
      }"
    >
      <mat-label>Accident Date 3</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE3?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATE3TEXT"
        (dateInput)="AccidentDate3Click('input', $event)"
        (dateChange)="AccidentDate3Click('change', $event)"
        matInput
        [matDatepicker]="AccidentDate3"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate3"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate3></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE3) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE3.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE3?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCIDENTDATE4),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCIDENTDATE4),
      }"
    >
      <mat-label>Accident Date 4</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.ACCIDENTDATE4?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ACCIDENTDATE4TEXT"
        (dateInput)="AccidentDate4Click('input', $event)"
        (dateChange)="AccidentDate4Click('change', $event)"
        matInput
        [matDatepicker]="AccidentDate4"
      />
      <mat-datepicker-toggle matSuffix [for]="AccidentDate4"></mat-datepicker-toggle>
      <mat-datepicker #AccidentDate4></mat-datepicker>
      @if (testBool && toolTipList?.ACCIDENTDATE4) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ACCIDENTDATE4.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ACCIDENTDATE4?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.EXPIRATIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.EXPIRATIONDATE),
      }"
    >
      <mat-label>Expiry Date</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.EXPIRATIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="EXPIRATIONDATETEXT"
        (dateInput)="ExpirtyDateClick('input', $event)"
        (dateChange)="ExpirtyDateClick('change', $event)"
        matInput
        [matDatepicker]="ExpiryDate"
      />
      <mat-datepicker-toggle matSuffix [for]="ExpiryDate"></mat-datepicker-toggle>
      <mat-datepicker #ExpiryDate></mat-datepicker>
      @if (testBool && toolTipList?.EXPIRATIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.EXPIRATIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.EXPIRATIONDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PLACEOFINJURY),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PLACEOFINJURY),
      }"
    >
      <mat-label>Place Of Accident</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.PLACEOFINJURY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PLACEOFINJURY"
      />
      @if (testBool && toolTipList?.PLACEOFINJURY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.PLACEOFINJURY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PLACEOFINJURY?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATESENTTOINSURER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATESENTTOINSURER),
      }"
    >
      <mat-label>Date Sent To Insurer</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.DATESENTTOINSURER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DATESENTTOINSURERTEXT"
        (dateInput)="DateSendToInsurerPiker('input', $event)"
        (dateChange)="DateSendToInsurerPiker('change', $event)"
        matInput
        [matDatepicker]="DATESENTTOINSURERPiker"
      />
      <mat-datepicker-toggle matSuffix [for]="DATESENTTOINSURERPiker"></mat-datepicker-toggle>
      <mat-datepicker #DATESENTTOINSURERPiker></mat-datepicker>
      @if (testBool && toolTipList?.DATESENTTOINSURER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DATESENTTOINSURER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATESENTTOINSURER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATERECEIVEDBYINSURER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATERECEIVEDBYINSURER),
      }"
    >
      <mat-label>Date Received By Insurer</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.DATERECEIVEDBYINSURER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DATERECEIVEDBYINSURERTEXT"
        (dateInput)="DateReceivedByInsurerPiker('input', $event)"
        (dateChange)="DateReceivedByInsurerPiker('change', $event)"
        matInput
        [matDatepicker]="DATERECEIVEDBYINSURERPiker"
      />
      <mat-datepicker-toggle matSuffix [for]="DATERECEIVEDBYINSURERPiker"></mat-datepicker-toggle>
      <mat-datepicker #DATERECEIVEDBYINSURERPiker></mat-datepicker>
      @if (testBool && toolTipList?.DATERECEIVEDBYINSURER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DATERECEIVEDBYINSURER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATERECEIVEDBYINSURER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTIMATEDAWARD),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTIMATEDAWARD),
      }"
    >
      <mat-label>Est. Award</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList?.ESTIMATEDAWARD?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ESTIMATEDAWARD"
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.ESTIMATEDAWARD) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ESTIMATEDAWARD.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ESTIMATEDAWARD?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CLAIMNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CLAIMNUMBER),
      }"
    >
      <mat-label>Claim Number</mat-label>
      <input
        name="CLAIMNUMBER"
        matTooltip="{{ toolTipList ? toolTipList?.CLAIMNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CLAIMNUMBER"
        matInput
      />
      @if (testBool && toolTipList?.CLAIMNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.CLAIMNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CLAIMNUMBER?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SETTLEMENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SETTLEMENTDATE),
      }"
    >
      <mat-label>Settlement Date</mat-label>
      <input
        matTooltip="{{ toolTipList ? toolTipList?.SETTLEMENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SETTLEMENTDATETEXT"
        (dateInput)="SettlementDateClick('input', $event)"
        (dateChange)="SettlementDateClick('change', $event)"
        matInput
        [matDatepicker]="SettlementDate"
      />
      <mat-datepicker-toggle matSuffix [for]="SettlementDate"></mat-datepicker-toggle>
      <mat-datepicker #SettlementDate></mat-datepicker>
      @if (testBool && toolTipList?.SETTLEMENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.SETTLEMENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SETTLEMENTDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
